import BackIcon from '@mui/icons-material/ArrowBack';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import MuiToolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { FormattedMessage, useIntl } from 'react-intl';

import { useTheme } from '@mui/material';
import { CountryCode } from 'libphonenumber-js';
import { getRouteApi, useNavigate } from '@tanstack/react-router';
import ContentView from '~/components/ContentView';
import UserForm from '~/components/UserForm';
import { useCreatePublisher } from '~/hooks/api/useCreatePublisher';
import { useSettingsByCategory } from '~/hooks/api/useSettingsByCategory';
import { toE164 } from '~/utils/phone-number-helpers';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import messages from './messages';

const route = getRouteApi('/users/create');

export const UserCreate = () => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const theme = useTheme();
  const navigate = useNavigate();
  const search = route.useSearch();
  const { data: settings, isFetching } = useSettingsByCategory('masterdata');
  const handleBackButton = () => {
    const query = new URLSearchParams(search);
    navigate({ to: query.get('from') || '/users' });
  };

  const createPublisherMutation = useCreatePublisher({
    onSuccess(publisher) {
      showSnackbar({
        message: intl.formatMessage(messages.saveSuccess),
      });
      navigate({
        to: '/users/$publisherId',
        params: { publisherId: publisher.id.toString() },
      });
    },
    onError() {
      showSnackbar({
        message: intl.formatMessage(messages.saveFailure),
      });
    },
  });

  return (
    <ContentView
      header={
        <AppBar position="static">
          <MuiToolbar>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="back"
              onClick={handleBackButton}
              style={{ marginRight: theme.spacing(2) }}
              size="large"
            >
              <BackIcon />
            </IconButton>
            <Typography variant="h6" style={{ flex: 1 }}>
              <FormattedMessage {...messages.title} />
            </Typography>
          </MuiToolbar>
        </AppBar>
      }
      isLoading={isFetching}
    >
      {settings ? (
        <UserForm
          onSubmit={(values) => {
            createPublisherMutation.mutate({
              ...values,
              middleName: values.middleName || undefined,
              phone: toE164(
                values.phone,
                settings.defaultRegionCallingCode as CountryCode
              ),
              birthDate: values.birthDate || null,
            });
          }}
        />
      ) : null}
    </ContentView>
  );
};
export default UserCreate;
